<template>
  <div class="eventos-wrapper">
    <v-container class="pt-10 pb-16">
      <div class="text-center mb-10">
        <h1 class="white--text text-h3 font-weight-black text-uppercase">Nossos Eventos</h1>
        <div class="mx-auto gradient-line my-4"></div>
        <p class="grey--text">Confira nossa programação completa e fotos dos eventos.</p>
      </div>

      <div v-if="loading" class="text-center"><v-progress-circular indeterminate color="red"></v-progress-circular></div>

      <v-timeline v-else :dense="$vuetify.breakpoint.smAndDown" class="mt-4">
        <v-timeline-item v-for="evento in eventos" :key="evento.id" color="#D32F2F" large>
          <template v-slot:opposite>
            <span class="text-h5 font-weight-bold white--text">{{ formatDate(evento.data) }}</span>
            <div class="grey--text text-caption">{{ formatTime(evento.data) }}</div>
          </template>

          <v-card dark color="#1E1E1E" elevation="10" class="rounded-lg">
            <v-carousel v-if="evento.fotos && evento.fotos.length > 0" height="250" hide-delimiters show-arrows-on-hover cycle>
              <v-carousel-item v-for="(foto, i) in evento.fotos" :key="i" :src="foto" cover></v-carousel-item>
            </v-carousel>

            <v-card-title class="text-h6 font-weight-bold">{{ evento.titulo }}</v-card-title>
            <v-card-subtitle class="red--text text--lighten-2 d-flex align-center">
              <v-icon small left color="red lighten-2">mdi-map-marker</v-icon>
              {{ evento.local }}
            </v-card-subtitle>
            <v-card-text class="grey--text text--lighten-1 pb-4">
              {{ evento.descricao }}
            </v-card-text>
            
            <div v-if="$vuetify.breakpoint.smAndDown" class="red darken-4 px-4 py-2 white--text font-weight-bold">
               {{ formatDate(evento.data) }} às {{ formatTime(evento.data) }}
            </div>
          </v-card>
        </v-timeline-item>
      </v-timeline>
    </v-container>
  </div>
</template>

<script>
import EventosService from '@/services/eventos.service';

export default {
  // CORREÇÃO AQUI: Nome composto
  name: "EventosPage",
  data: () => ({ eventos: [], loading: true }),
  async mounted() {
    try {
      const data = await EventosService.getAll();
      this.eventos = data.sort((a, b) => new Date(b.data) - new Date(a.data));
    } catch (error) {
        console.error("Erro ao carregar eventos:", error);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    formatDate(date) { return new Date(date).toLocaleDateString('pt-BR'); },
    formatTime(date) { return new Date(date).toLocaleTimeString('pt-BR', {hour:'2-digit', minute:'2-digit'}); }
  }
};
</script>

<style scoped>
.eventos-wrapper { background-color: #121212; min-height: 100vh; }
.gradient-line { width: 80px; height: 4px; background: linear-gradient(90deg, #D32F2F, #ff7961); }
</style>